var _style, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaughing(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000059995355608207403900000004835239350218095804_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 92",
    style: {
      enableBackground: "new 0 0 92 92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E3E80;}\n\t.st1{fill:none;stroke:#1E3E80;stroke-width:3.16;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#59AC31;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,50.7c-0.7,0-1.3-0.6-1.3-1.3V21.6c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3v27.8 C47.3,50.1,46.7,50.7,46,50.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.6,41.8c0,0-5.5-3.1-10.4,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.4,41.8c0,0,5.5-3.1,10.4,1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,58.6c-0.2-0.1-0.5-0.1-0.7,0c0,0,0,0-0.1,0H29.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0 c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.8,0.3-1.3,1.2-1,2.1c2.3,7.7,9.7,13,18.1,13s15.8-5.3,18.1-13C64.4,59.9,63.9,58.9,63,58.6 L63,58.6z M46,70.4c-6.1,0-11.5-3.4-14-8.4h27.9C57.5,67,52.1,70.4,46,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,92C20.6,92,0,71.4,0,46S20.6,0,46,0s46,20.6,46,46S71.4,92,46,92z M46,3.3C22.5,3.3,3.3,22.5,3.3,46 S22.4,88.7,46,88.7S88.7,69.5,88.7,46S69.5,3.3,46,3.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-94.4-66.9c-2.2-2.2-2.2-5.8,0-8c0.7-0.7,1.8-1.3,3.2-1.7c0.8-0.2,1.6-0.4,2.5-0.6 c0.9-0.2,1.8-0.3,2.6-0.3c0.3,0,0.6-0.1,0.8-0.1c0.2,0,0.3,0,0.3,0c0.7,0,1.2,0.5,1.2,1.2c0,0.1,0,0.2,0,0.3 c0,0.2,0,0.5-0.1,0.8c-0.1,0.9-0.2,1.8-0.4,2.6c-0.2,0.9-0.4,1.8-0.6,2.5c-0.4,1.4-1,2.5-1.7,3.2 C-88.6-64.7-92.2-64.7-94.4-66.9L-94.4-66.9z M-88.2-74.9c-0.8,0.2-1.6,0.3-2.3,0.5c-1.1,0.3-1.9,0.7-2.3,1.1 c-1.3,1.3-1.3,3.4,0,4.8c1.3,1.3,3.5,1.3,4.8,0c0.4-0.4,0.8-1.2,1.1-2.3c0.2-0.7,0.4-1.4,0.5-2.3c0.1-0.7,0.2-1.5,0.3-2.2 C-86.7-75.1-87.5-75-88.2-74.9L-88.2-74.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-31.4-66.9c-0.7-0.7-1.3-1.8-1.7-3.2c-0.2-0.8-0.4-1.6-0.6-2.5c-0.2-0.9-0.3-1.8-0.4-2.6 c0-0.3-0.1-0.6-0.1-0.8c0-0.2,0-0.3,0-0.3c0-0.7,0.5-1.2,1.2-1.2c0.1,0,0.2,0,0.3,0c0.2,0,0.5,0,0.8,0.1 c0.9,0.1,1.8,0.2,2.6,0.3c0.9,0.2,1.8,0.3,2.5,0.6c1.4,0.4,2.5,1,3.2,1.7c2.2,2.2,2.2,5.8,0,8S-29.2-64.7-31.4-66.9L-31.4-66.9z  M-31.8-75.2c0.1,0.7,0.2,1.5,0.3,2.2c0.2,0.8,0.3,1.6,0.5,2.3c0.3,1.1,0.7,1.9,1.1,2.3c1.3,1.3,3.4,1.3,4.8,0 c1.3-1.3,1.3-3.5,0-4.8c-0.4-0.4-1.2-0.8-2.3-1.1c-0.7-0.2-1.4-0.4-2.3-0.5C-30.3-75.1-31.1-75.2-31.8-75.2L-31.8-75.2z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaughing);
export default __webpack_public_path__ + "static/media/Laughing.93261a3dd5fc0c2c3e5d22b3a6bfa0ca.svg";
export { ForwardRef as ReactComponent };